import {
  BrowserRouter,
  Redirect as RedirectDom,
  Route as RouteDom,
  Switch as SwitchDom,
} from 'react-router-dom';

// dirty fix for type error
export const Router: any = BrowserRouter;

// dirty fix for type error
export const Redirect: any = RedirectDom;

// dirty fix for type error
export const Route: any = RouteDom;

// dirty fix for type error
export const Switch: any = SwitchDom;
